/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Newsletter_Resubscribe_Done_DescriptionInputs */

const en_newsletter_resubscribe_done_description = /** @type {(inputs: Newsletter_Resubscribe_Done_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.email} is back on the list.`)
};

/**
* | output |
* | --- |
* | "{email} is back on the list." |
*
* @param {Newsletter_Resubscribe_Done_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_resubscribe_done_description = /** @type {((inputs: Newsletter_Resubscribe_Done_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Resubscribe_Done_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_resubscribe_done_description(inputs)
});